import {
  Annotations,
  type EditorPlugin,
  type MountHandler,
} from '@aha-app/aha-editor-v2';
import AhaDrawer from 'javascripts/drawer';
import { type RecordId } from 'javascripts/shared-types';
import $ from 'jquery';
import AhaEditorFieldV2Controller from '../../controllers/AhaEditorFieldV2Controller';

function getAnnotationKeyFromHash(
  container: HTMLDivElement
): string | undefined {
  const drawer = AhaDrawer.instance();
  let location: URL | undefined;

  if (container && drawer?.elementIsInDrawer($(container))) {
    const drawerUrl = drawer.currentUrl();
    if (drawerUrl) {
      location = new URL(drawerUrl, window.location.toString());
    }
  } else {
    location = new URL(window.location.toString());
  }

  if (!location) return;

  const hash = location.hash.substring(1);
  const segments = hash.split('/');
  const annotationKeys = segments
    .filter(segment => segment.startsWith('annotation_'))
    .map(segment => segment.replace('annotation_', ''));

  if (annotationKeys.length > 0) return annotationKeys[0];
}

function selectAnnotationInSidePanel(
  documentId: RecordId,
  annotationKey: string
): void {
  // Listen to this event so that we know reactive container has rendered
  // Event emitted in app/views/annotations/_index.html.erb
  document.addEventListener(
    'aha.annotations-loaded',
    event => {
      if (documentId !== event.detail.annotatableId) return;

      $(`#annotation-details-${annotationKey}`).trigger('selectannotations', [
        {
          ids: [annotationKey],
          scroll: true,
          showIfResolved: true,
        },
      ]);
    },
    { once: true }
  );
}

const SelectAnnotationFromUrlPlugin = (): EditorPlugin => {
  const onMount: MountHandler = ahaEditor => {
    const { editor, controller } = ahaEditor;
    const editorFieldController = controller.findControllerInstance(
      AhaEditorFieldV2Controller
    );
    if (!editorFieldController) return;

    const container = controller.editorContainer;
    if (!container) return;

    const annotationKey = getAnnotationKeyFromHash(container);
    if (!annotationKey) return;

    const provider = ahaEditor.getProvider('annotations');
    if (!provider) return;

    const annotation = Annotations.getAnnotation(editor, annotationKey);
    if (!annotation || !annotation.range.current) return;

    const editorFieldContainer = editorFieldController.container;
    if (!editorFieldContainer) return;

    // Show the comments side panel...
    editorFieldController.actionShowSidePanel({
      open: true,
      panel: 'comments',
    });

    // ... then select the annotation
    selectAnnotationInSidePanel(
      editorFieldController.documentId,
      annotationKey
    );
  };

  return {
    name: 'Annotation link plugin',
    handlers: {
      onMount,
    },
  };
};

export default SelectAnnotationFromUrlPlugin;
